"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductImage = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _defaultImage = _interopRequireDefault(require("./default-image"));
var _excluded = ["alt", "src", "isAltReal", "border", "dataTestId", "sources", "lazy", "fetchPriority"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  alt: _propTypes["default"].string.isRequired,
  src: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  isAltReal: _propTypes["default"].bool,
  lazy: _propTypes["default"].bool,
  border: _propTypes["default"].string,
  fetchPriority: _propTypes["default"].oneOf(['low', 'auto', 'high']),
  sources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    media: _propTypes["default"].string,
    srcsetList: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      template: _propTypes["default"].string,
      scale: _propTypes["default"].string
    }))
  }))
};
var defaultProps = {
  dataTestId: null,
  isAltReal: false,
  src: '',
  lazy: false,
  border: null,
  sources: [],
  fetchPriority: null
};
var StyledPicture = _styledComponents["default"].picture.withConfig({
  displayName: "product-image__StyledPicture",
  componentId: "sc-cuzgd0-0"
})(["position:relative;width:100%;padding-top:133.33%;"]);
var ProductImage = exports.ProductImage = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var alt = _ref.alt,
    src = _ref.src,
    isAltReal = _ref.isAltReal,
    border = _ref.border,
    dataTestId = _ref.dataTestId,
    sources = _ref.sources,
    lazy = _ref.lazy,
    fetchPriority = _ref.fetchPriority,
    props = _objectWithoutProperties(_ref, _excluded);
  var imgTypes = ['image/webp', 'image/jpeg'];
  var defaultBorderStyle = 'var(--border-width-xs) solid var(--color-global-grey300)';
  var borderStyle = border || defaultBorderStyle;
  var styles = {
    display: 'block',
    width: '100%',
    objectFit: 'cover',
    boxSizing: 'border-box',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    border: borderStyle
  };
  var hasTemplate = function hasTemplate(_ref2) {
    var template = _ref2.template;
    return template && typeof template === 'string';
  };
  var isMultiSrc = function isMultiSrc(srcs) {
    return srcs && srcs.length && srcs.every(hasTemplate);
  };
  var getSrc = function getSrc() {
    return src.includes('?') ? "".concat(src, "&") : "".concat(src, "?");
  };
  var buildImageSrc = function buildImageSrc(params) {
    if (!(params !== null && params !== void 0 && params.length)) {
      return src;
    }
    return "".concat(getSrc()).concat(params.join('&'));
  };
  var getSrcset = function getSrcset(type, srcs) {
    var params = [];
    if (type === 'image/webp') params.push('fmt=webp');
    if (!isMultiSrc(srcs)) {
      return buildImageSrc(params);
    }
    return srcs.map(function (_ref3) {
      var template = _ref3.template,
        scale = _ref3.scale;
      var paramsWithTpl = ["$".concat(template, "$")].concat(params);
      var scaleStr = scale ? " ".concat(scale) : '';
      return "".concat(buildImageSrc(paramsWithTpl)).concat(scaleStr);
    }).join(', ');
  };
  var isExist = function isExist(arr) {
    return arr && Array.isArray(arr) && arr.length > 0;
  };
  if (!src) {
    return /*#__PURE__*/_react["default"].createElement(_defaultImage["default"], {
      alt: alt,
      isAltReal: isAltReal
    });
  }
  return /*#__PURE__*/_react["default"].createElement(StyledPicture, {
    className: "fuse-product-image"
  }, imgTypes.map(function (type) {
    if (isExist(sources)) {
      return sources.map(function (_ref4) {
        var media = _ref4.media,
          srcsetList = _ref4.srcsetList;
        return /*#__PURE__*/_react["default"].createElement("source", {
          key: media + type,
          media: media,
          type: type,
          srcSet: getSrcset(type, srcsetList)
        });
      });
    }
    return /*#__PURE__*/_react["default"].createElement("source", {
      key: type,
      type: type,
      srcSet: getSrcset(type)
    });
  }), /*#__PURE__*/_react["default"].createElement("img", _extends({
    src: src,
    alt: alt,
    ref: ref,
    className: "fuse-product-image__img",
    loading: lazy ? 'lazy' : 'eager',
    fetchpriority: fetchPriority || 'auto',
    "data-testid": dataTestId || 'fuse-product-image',
    "aria-hidden": isAltReal ? undefined : 'true',
    style: styles
  }, props)));
});
ProductImage.propTypes = propTypes;
ProductImage.defaultProps = defaultProps;
ProductImage.displayName = 'ProductImage';
var _default = exports["default"] = ProductImage;